import React from 'react';
import styled from '@emotion/styled';

export const IconDrills = () => {
  return (
    <StyledIconDrillsSpan className="icon-svg IconDrills">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs />
        <g className="a">
          <rect className="b" width="24" height="24" />
          <path className="c" d="M0,15.5,14.109,7.75,0,0Z" transform="translate(5.5 3.5)" />
        </g>
      </svg>
    </StyledIconDrillsSpan>
  );
};

const StyledIconDrillsSpan = styled.span`
  & .a {
    opacity: 0.7;
  }

  & .b {
    fill: none;
  }

  & .c {
    stroke: #fff;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
    stroke-width: 2px;
  }

  display: inline-block;
  vertical-align: sub;
`;
